import React from 'react';
import Button from './Button';

type NumberPadProps = {
  onNumberClick: (num: string) => void;
  onDelete: () => void;
  className?: string;
};

const NumberPad = ({ onNumberClick, onDelete, className }: NumberPadProps) => {
  return (
    <div className={className}>
      <div className="number-pad">
        {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map((num) => (
          <Button
            key={num}
            className={`number-btn number-${num}`}
            onClick={() => onNumberClick(num)}
          >
            {num}
          </Button>
        ))}
        <Button
          className="number-btn number-0"
          onClick={() => onNumberClick('0')}
        >
          0
        </Button>
        <Button className="number-btn delete-btn" onClick={onDelete}>
          ⌫
        </Button>
      </div>
    </div>
  );
};

export default NumberPad;
